import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
export default /*#__PURE__*/ _defineComponent({
    __name: 'custom_html_module',
    props: ['d'],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                innerHTML: __props.d.content
            }, null, 8, _hoisted_1));
        };
    }
});
